/**
 * Les drapeaux du selecteur de langue, DESSINES.
 *
 * POURQUOI PAS DES EMOJI, QUI TENAIENT EN UNE LIGNE
 *
 * Ils y etaient, et le selecteur etait muet : David ne voyait aucun drapeau. La cause
 * n'est pas dans le code, elle est dans la police. Un drapeau en emoji est une paire
 * d'indicatifs regionaux Unicode (U+1F1EB U+1F1F7 pour la France), et AUCUNE version de
 * Windows n'embarque les glyphes correspondants : le navigateur y rend deux lettres
 * dans des cadres, ou rien du tout. macOS et iOS les rendent, ce qui explique qu'on ne
 * l'ait jamais vu de notre cote.
 *
 * Remplacer un emoji par un autre n'aurait donc rien change. Un dessin, si : il ne
 * depend d'aucune police et s'affiche partout a l'identique.
 *
 * TRACE A LA MAIN PLUTOT QU'IMPORTE. Cinq drapeaux de quelques rectangles ne valent pas
 * une dependance de plusieurs centaines de kilo-octets, ni un fichier d'images a servir.
 *
 * ⚠️ Le roumain et le moldave portent les MEMES trois bandes bleu-jaune-rouge. Sans
 * l'embleme, les deux lignes du menu seraient indiscernables — et ce sont precisement
 * les deux langues que les poseurs choisissent le plus. L'embleme moldave est donc
 * suggere, pas fidele : sa fonction ici est de distinguer, pas de blasonner.
 */

const DESSINS = {
  fr: (
    <>
      <rect width="1" height="2" x="0" fill="#002654" />
      <rect width="1" height="2" x="1" fill="#ffffff" />
      <rect width="1" height="2" x="2" fill="#ed2939" />
    </>
  ),

  en: (
    <>
      <rect width="3" height="2" fill="#012169" />
      {/* Les diagonales blanches, puis les rouges par-dessus, decalees : c'est ce
          decalage qui fait la croix de saint Patrick et evite une simple etoile. */}
      <path d="M0,0 L3,2 M3,0 L0,2" stroke="#ffffff" strokeWidth="0.4" />
      <path d="M0,0 L3,2 M3,0 L0,2" stroke="#c8102e" strokeWidth="0.2" />
      <path d="M1.5,0 V2 M0,1 H3" stroke="#ffffff" strokeWidth="0.66" />
      <path d="M1.5,0 V2 M0,1 H3" stroke="#c8102e" strokeWidth="0.4" />
    </>
  ),

  ro: (
    <>
      <rect width="1" height="2" x="0" fill="#002b7f" />
      <rect width="1" height="2" x="1" fill="#fcd116" />
      <rect width="1" height="2" x="2" fill="#ce1126" />
    </>
  ),

  mo: (
    <>
      <rect width="1" height="2" x="0" fill="#0046ae" />
      <rect width="1" height="2" x="1" fill="#ffd200" />
      <rect width="1" height="2" x="2" fill="#cc092f" />
      <circle cx="1.5" cy="1" r="0.34" fill="none" stroke="#a5153a" strokeWidth="0.12" />
    </>
  ),

  pl: (
    <>
      <rect width="3" height="1" y="0" fill="#ffffff" />
      <rect width="3" height="1" y="1" fill="#dc143c" />
    </>
  ),
};

/**
 * Un drapeau. `titre` le rend lisible aux lecteurs d'ecran ; sans lui l'image serait
 * decorative, or ici elle porte l'information « quelle langue ».
 */
export default function Drapeau({ code, titre = '', className = 'w-[18px] h-3 rounded-[1px] shrink-0' }) {
  const dessin = DESSINS[code];
  if (!dessin) return null;
  return (
    <svg
      viewBox="0 0 3 2"
      className={className}
      role="img"
      aria-label={titre || undefined}
      aria-hidden={titre ? undefined : true}
      data-testid={`drapeau-${code}`}
    >
      {titre && <title>{titre}</title>}
      {dessin}
      {/* Une liste de drapeaux a fond blanc se perd sur un fond blanc : le lisere le
          borne sans le colorer. */}
      <rect width="3" height="2" fill="none" stroke="rgba(0,0,0,0.18)" strokeWidth="0.06" />
    </svg>
  );
}
